import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MainLayout from './layouts/main-layout.js';
import PosLayout from './layouts/pos-layout.js';
import LoginPage from './pages/Auth/Login/LoginPage.jsx';
import DashboardPage from './pages/Auth/DashBoard/Dashboard.jsx';
import NotFoundPage from './components/Common/NotFoundPage.jsx';
import PasswordReset from '../src/pages/Auth/Reset-Password/reset-password.jsx';
import ForgotPasswordPopup from './components/popup/ForgotPassword.jsx';
import Sidebar from './components/Common/Sidebar.jsx';
import Header from './components/Common/Header.jsx';
import ProductPage from '../src/pages/Auth/Product/productPage.jsx';
import CategoryPage from '../src/pages/Auth/Category/category.jsx';
import SubCategoryPage from '../src/pages/Auth/SubCategory/sub-category.jsx';
import ServicePage from '../src/pages/Auth/Service/service.jsx';
import CustomerPage from '../src/pages/Auth/Customers/customer.jsx';
import ViewCustomerPage from '../src/pages/Auth/Customers/view-customer.jsx';
import EmployeePage from '../src/pages/Auth/Employee/employee-page.jsx';
import DepartmentPage from '../src/pages/Auth/Department/department-page.jsx';
import DepartmentUserPage from '../src/pages/Auth/Employee/departmentUser-page.jsx';
import StorePage from '../src/pages/Auth/store/store-page.jsx';
import SubscriptionPage from '../src/pages/Auth/subscription/subscription-page.jsx';
import OfferPage from '../src/pages/Auth/offers/offer-page.jsx';
import SettingsPage from '../src/pages/Auth/settings/settings-page.jsx';
import ProfileAndPasswordPage from '../src/pages/Auth/Profile/profileAndPassword.jsx';
import GeneralSettings from './pages/Auth/settings/general-settings.jsx';
import TaxSettings from './pages/Auth/settings/tax-settings.jsx';
import Booking from './pages/Auth/Booking/Booking.jsx';
import BookingCalender from './pages/Auth/Booking/booking-calender.jsx';
import Expense from './pages/Auth/Expense/expense.jsx';
import Report from './pages/Auth/Report/report.jsx';
import PurchasePage from './pages/Auth/Purchase/purchase.jsx';
import CampaignPage from './pages/Auth/Campaign/campaign-page.jsx';
import SendCampaignPage from './pages/Auth/Campaign/sendCampaign-page.jsx';
import CampaignHistoryPage from './pages/Auth/Campaign/campaignHistory.jsx';
import CampaignHistoryViewPage from './pages/Auth/Campaign/CampaignHistoryViewPage.jsx';
import ReportPage from './pages/Auth/Report/report-page.jsx';
import EarningReports from './pages/Auth/Report/earning-report.jsx';
import SalesReport from './pages/Auth/Report/sales-report.jsx';
import CustomerReport from './pages/Auth/Report/customer-page.jsx';
import GraphReport from './pages/Auth/Report/graph-report.jsx';
import POSPage from './pages/Auth/Pos/pos-page.jsx';
import ReturnPage from './pages/Auth/Return/return-list.jsx';
import ReturnAddPage from './pages/Auth/Return/return-page.jsx';
import SalesPage from './pages/Auth/sales/sales-page.jsx';
import AttributesPage from './pages/Auth/Attributes/attributes-page.jsx';
import SuppliersPage from './pages/Auth/suppliers/supplier-page.jsx';
import PurchasePaymentPage from './pages/Auth/Purchase/purchasepayment.jsx';
import StocskPage from './pages/Auth/stock/stock-page.jsx';
import ComboOfferPage from './pages/Auth/ComboOffer/combo-offer.jsx';
import StockExchangePage from './pages/Auth/StockTransfer/stockTransfer-page.jsx';
import PurchaseReturnPage from './pages/Auth/Purchase/purchaseReturn.jsx';
import ProfitPage from './pages/Auth/Report/profit-page.jsx';
import BannerPage from './pages/Auth/Banner/Banner.jsx';
import OrderPage from './pages/Auth/Orders/OrdersPage.jsx';

const AppContent = () => {
  const location = useLocation();

  const hideSidebar = [
    '/login',
    '/signup',
    '/reset-password',
    '/forgot-password',
    '/pos'
  ].some(path => location.pathname.startsWith(path));


  // const hideHeader = [
  //   '/login',
  //   '/signup',
  //   '/reset-password',
  //   '/forgot-password'
  // ].some(path => location.pathname.startsWith(path));

  return (
    <div className="app-container">
      {!hideSidebar && <Sidebar />}
      <div className="main-area">
        {!hideSidebar && <Header />}
        <div className="content-wrapper">
          <Routes>
            <Route path='/' element={<Navigate to="/login" />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/reset-password/:token' element={<PasswordReset />} />
            <Route path='/forgot-password' element={<ForgotPasswordPopup />} />
            <Route element={<PosLayout />}>
              <Route path="/pos" element={<POSPage />} />
            </Route>
            <Route element={<MainLayout />}>
              <Route path='/dashboard' element={<DashboardPage />} />
              <Route path='*' element={<NotFoundPage />} />
              <Route path='/products/*' element={< ProductPage />} />
              <Route path='/banner/*' element={< BannerPage /> } />
              <Route path='/orders/*' element={< OrderPage /> } />
              <Route path='/category/*' element={<CategoryPage />} />
              <Route path='/sub-category/*' element={<SubCategoryPage />} />
              <Route path="/attributes/*" element={<AttributesPage />} />
              <Route path='/services/*' element={<ServicePage />} />
              <Route path="/customers/customer/:id/edit" element={<CustomerPage />} />
              <Route path='/customers/customer/:id' element={<ViewCustomerPage />} />
              <Route path='/customers/*' element={<CustomerPage />} />
              <Route path='/departments/*' element={<DepartmentPage />} />
              <Route path='/employees/*' element={<EmployeePage />} />
              <Route path='/:departmentId/users' element={<DepartmentUserPage />} />
              <Route path='/stores/*' element={<StorePage />} />
              <Route path='/subscriptions/*' element={<SubscriptionPage />} />
              <Route path='/coupons/*' element={<OfferPage />} />
              <Route path="/settings/" element={<SettingsPage />}>


                {/* Default route -> General Settings */}
                <Route index element={<GeneralSettings />} />


                <Route path="profile" element={<ProfileAndPasswordPage />} />

                {/* Tax tab */}
                <Route path="tax/*" element={<TaxSettings />} />
              </Route>
              <Route path="/bookings/*" element={<Booking />} />
              <Route path="/bookingcalender" element={<BookingCalender />} />
              <Route path="/expense/*" element={<Expense />} />
              <Route path="/suppliers/*" element={<SuppliersPage />} />
              <Route path="/generalsettings/" element={<GeneralSettings />} />
              <Route path="/purchases/*" element={<PurchasePage />} />
              <Route path="/purchaseinvoice/*" element={<PurchasePaymentPage />} />
              <Route path="/purchasereturn/*" element={<PurchaseReturnPage />} />
              <Route path="/stocks" element={<StocskPage />} />
              <Route path="/stockexchange" element={<StockExchangePage />} />
              <Route path="/campaigns/*" element={<CampaignPage />} />
              <Route path="/sendcampaigns/:campaignId" element={<SendCampaignPage />} />
              <Route path="/campaign/history" element={<CampaignHistoryPage />} />
              <Route path="/campaign/history/view" element={<CampaignHistoryViewPage />} />
              <Route path="/combooffers/*" element={<ComboOfferPage />} />
              <Route path="/reports" element={<Report />}>
                <Route index element={<Navigate to="summary" />} />
                <Route path="summary" element={<ReportPage />} />
                <Route path="earning" element={<EarningReports />} />
                <Route path="sales" element={<SalesReport />} />
                <Route path="customer" element={<CustomerReport />} />
                <Route path="graph" element={<GraphReport />} />
                <Route path="profitandloss" element={<ProfitPage />} />
              </Route>
              <Route path="/sales-return" element={<ReturnPage />} />
              <Route path="/sales-return/add" element={<ReturnAddPage />} />
              <Route path="/sales/*" element={<SalesPage />} />
            </Route>
          </Routes>
        </div>
      </div>
    </div>
  );
};


const AppRoutes = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};


export default AppRoutes;